module.exports = __webpack_public_path__ + "img/61.dfba474d.webp";